import { render, staticRenderFns } from "./Transactionaduit.vue?vue&type=template&id=56dfc66c&scoped=true"
import script from "./Transactionaduit.vue?vue&type=script&lang=js"
export * from "./Transactionaduit.vue?vue&type=script&lang=js"
import style0 from "./Transactionaduit.vue?vue&type=style&index=0&id=56dfc66c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dfc66c",
  null
  
)

export default component.exports